import { Injectable } from '@angular/core';
import {LoadingController} from '@ionic/angular';
import {HttpClient} from '@angular/common/http';
import {ICreateLoadingOptions} from '../data/misc/LoadingController.model';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  LOADING_MESSAGE = "Loading. Please wait...";
  SAVING_MESSAGE = 'Saving. Please wait ...';
  constructor(
    private loadingController: LoadingController,
    private http: HttpClient,
  ) {
  }

  async replaceSpinner(loading: HTMLIonLoadingElement, options: ICreateLoadingOptions) {
    const {
      svgUrl,
      customIconName = 'hp-loading-spinner',
      iconWidth = 50
    } = options || {};
    const url = svgUrl || `../../assets/custom-icons/${customIconName}.svg`;
    if (loading && url) {
      try {
        const svg = await firstValueFrom(this.http.get(url, { responseType: 'text' }));
        const spinner = loading.querySelector('ion-spinner');
        if (spinner?.shadowRoot && svg) {
          const { shadowRoot } = spinner;
          shadowRoot.innerHTML = svg;
          if (iconWidth) {
            spinner.style.width = `${iconWidth}px`;
            spinner.style.height = `${iconWidth}px`;
          }
        }
      } catch (e) {
        console.error(e);
      }
    }
  }

  async create(options?: ICreateLoadingOptions)
  {
    return this.createWithMessage(this.LOADING_MESSAGE, options);
  }

  async createSave(options?: ICreateLoadingOptions)
  {
    return this.createWithMessage(this.SAVING_MESSAGE, options);
  }

  async createWithMessage(message: string, options?: ICreateLoadingOptions)
  {
    const loading = await this.loadingController.create({
      message: message,
      spinner: options?.animation === 'blink' ? 'circles' : 'crescent',
      duration: 7000,
      cssClass: options?.cssClass || 'custom-loading',
    });
    await this.replaceSpinner(loading, options!);
    return loading;
  }

  async createWithMessageAndNoDuration(message: string, options?: ICreateLoadingOptions)
  {
    const loading = await this.loadingController.create({
      message: message,
      spinner: options?.animation === 'blink' ? 'circles' : 'crescent',
      cssClass: options?.cssClass ||  'custom-loading',
    });
    await this.replaceSpinner(loading, options!);
    return loading;
  }

  async createWithMessageAndDuration(message: string, duration: number, options?: ICreateLoadingOptions)
  {
    const loading = await this.loadingController.create({
      message: message,
      spinner: options?.animation === 'blink' ? 'circles' : 'crescent',
      duration: duration,
      cssClass: options?.cssClass || 'custom-loading'
    });
    await this.replaceSpinner(loading, options!);
    return loading;
  }
}
